import validator from 'validator';
import { typesActionsRaports } from '../types/actions-raports';
import { measuresTypes, TMeasure } from '../types/measures';

const fullName = (user: { firstName: string; lastName: string }) =>
  user && `${user.firstName} ${user.lastName}`;

const prettyDate = (date: any) => {
  if (date) {
    const obj = new Date(date);
    const month = getMonth(date);
    const day = obj.getDate();
    const year = obj.getFullYear();

    return day + ' ' + month + ' ' + year;
  } else {
    return '-';
  }
};

const getMonth = (date: any) => {
  const monthNames = [
    'Ianuarie',
    'Februarie',
    'Martie',
    'Aprilie',
    'Mai',
    'Iunie',
    'Iulie',
    'August',
    'Septembrie',
    'Octombrie',
    'Noiembrie',
    'Decembrie'
  ];

  const d = new Date(date);
  return monthNames[d.getMonth()];
};

const getYear = (date: any) => {
  if (date) {
    const obj = new Date(date);
    return obj && obj.getFullYear().toString();
  }
};

const formatDate = (date: Date) =>
  date &&
  `${date.getFullYear()}-${
    date.getMonth() < 9 ? `0${date.getMonth() + 1}` : date.getMonth() + 1
  }-${date.getDate() <= 9 ? `0${date.getDate()}` : date.getDate()}`;

const checkEmail = (email: string) => {
  validator.isEmail(email);
};

const mapRaportsTitle = (type: string, institutionPrivate: boolean) => {
  switch (type) {
    case typesActionsRaports.REPORT_PERMISSIONS:
      return 'Permisiuni';
    case typesActionsRaports.ADDITIONAL_DOCUMENT:
      return 'Adăugare document adițional';
    case typesActionsRaports.ADD_FOLLOWUP:
      return 'Adăugare raport de followup';
    case typesActionsRaports.EDIT_RAPORT:
      return !institutionPrivate
        ? 'Editare raport'
        : 'Editare raport / contract';
    case typesActionsRaports.ADD_RAPORT:
      return !institutionPrivate
        ? 'Adăugare raport'
        : 'Adăugare raport / contract';
  }
};

const buildMonitorizationMessage = (
  type: TMeasure,
  fileCount: number,
  measureCount: number,
  expiredMeasureCount: number,
  expiredMeasureCountToday: number
) =>
  `Au fost adăugate ${fileCount} ${
    fileCount === 1 ? 'fișier' : 'fișiere'
  } și ${measureCount} ${
    type === measuresTypes.MEASURES
      ? measureCount === 1
        ? 'măsură'
        : 'măsuri'
      : measureCount === 1
      ? 'recomandare'
      : 'recomandări'
  } din care ${expiredMeasureCount > 0 ? expiredMeasureCount : ''} ${
    expiredMeasureCount === 0
      ? 'niciuna nu a'
      : expiredMeasureCount === 1
      ? 'a'
      : 'au'
  } expirat. ${
    expiredMeasureCountToday > 0
      ? expiredMeasureCountToday === 1
        ? 'Una a expirat astăzi.'
        : `${expiredMeasureCountToday} au expirat astăzi.`
      : ''
  }`;

const capitalizeFirstLetter = (string: string) =>
  string.charAt(0).toUpperCase() + string.slice(1);

const combineFilesNames = (files: FileList) =>
  Array.from(files)
    .map(file => file.name)
    .join(', ');

export {
  fullName,
  getMonth,
  getYear,
  prettyDate,
  formatDate,
  checkEmail,
  mapRaportsTitle,
  buildMonitorizationMessage,
  capitalizeFirstLetter,
  combineFilesNames
};
